<p>
  Table component is DEPRECATED and will be not accessible in future MAJOR Release. Use
  <app-text-code>&lt;mad-data-table&gt;</app-text-code> instead.
</p>

<p>Tables are for organizing large volumes of data that users can scan, compare and perform actions on.</p>
<p>
  Please find the main documentation here:
  <a href="https://material.angular.io/components/table/overview" title="Material Design Table">Material Design table</a><br />
  In the following only additional features are documented
</p>
<p>
  Import the <app-text-code>TableModule</app-text-code> in your app.module.ts and use it via
  <app-text-code>&lt;mad-table&gt;</app-text-code>.
</p>

<example-viewer [example]="tableComponent"></example-viewer>
